var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"myCenter"},[_c('Header'),_c('div',{staticClass:"content"},_vm._l((_vm.bannerList),function(item,index){return _c('img',{key:index,attrs:{"src":item.sourceUrl}})}),0),_c('BackTop',{attrs:{"hasShopping":false}}),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }